var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body-editor" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("a-textarea", {
        attrs: {
          value: _vm.body,
          placeholder: "Enter your message body text",
          rows: _vm.rows,
          maxLength: 1024,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("update:body", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "textarea-footer" }, [
        !_vm.disableFormatting
          ? _c(
              "div",
              { staticClass: "format-buttons" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: "Bold" } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.insertFormat("*")
                          },
                        },
                      },
                      [_vm._v("B")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: "Italic" } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.insertFormat("_")
                          },
                        },
                      },
                      [_c("i", [_vm._v("I")])]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: "Strikethrough" } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.insertFormat("~")
                          },
                        },
                      },
                      [_c("s", [_vm._v("S")])]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  { attrs: { size: "small" }, on: { click: _vm.addVariable } },
                  [_vm._v("+ Add variable")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "char-count" }, [
          _vm._v(_vm._s((_vm.body || "").length) + "/1024"),
        ]),
      ]),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "error-text" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.variables.length
        ? _c(
            "div",
            { staticClass: "variables-section" },
            [
              _c("div", { staticClass: "variables-header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("whatsapp_business_api.variables"))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.defaultVariableName"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.variables, function (variable, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "variable-row" },
                  [
                    _c("a-input", {
                      attrs: { value: variable.variable, disabled: "" },
                    }),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        value: variable.example,
                        placeholder: _vm.$t("whatsapp_business_api.example"),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateVariableExample(
                            i,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Body "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }